export default {
  buttons: {
    sign_in: 'Iniciar sesión',
    sign_up: 'Registrarse',
    logout: 'Cerrar sesión',
  },
  logout_confirm: {
    title: '¿Cerrar sesión?',
    description: '¿Seguro que quieres cerrar sesión?',
    cancel: 'Cancelar',
    confirm: 'Cerrar sesión',
  },
};
